<template>
  <p class="currency-disclaimer small">
    <span v-if="onlyUsd">
      {{ $t('allPurchases') }}
    </span>

    <span v-else-if="chargeableCurrency">
      {{ $t('currencyDisclaimerCharge') }}
    </span>

    <span v-else-if="currency != 'USD'">
      {{ $t('currencyDisclaimer') }}
    </span>
  </p>
</template>

<script>
import CurrencyApi from './currency-api'

export default {

  props: ['currency', 'chargeablecurrencies'],
  data() {
    return {
      allCurrencies: null
    }
  },

  computed: {
    onlyUsd() {
      if (this.allCurrencies) {
        return this.allCurrencies.length <= 1
      } else if (this.chargeablecurrencies) {
        return this.chargeablecurrencies.length <= 1
      } else {
        return true
      }
    },

    chargeableCurrency() {
      if (this.chargeablecurrencies) {
        return this.chargeablecurrencies.includes(this.currency)
      } else {
        return false
      }
    }
  },

  watch: {
    chargeablecurrencies() {
      this.$emit('only-usd-emit', this.onlyUsd)
    }
  },

  mounted() {
    this.setOptions()
    CurrencyApi.availableCurrencies().then(currencies => {
      if (currencies.currencies) {
        this.allCurrencies = currencies.currencies
      }

      this.$emit('only-usd-emit', this.onlyUsd)
    })
  },

  methods: {
    setOptions() {
      // Sets form values if they are unset.  If you use the back button, the form is rendered blank
      // 'Selected' does not affect state of form, only what is originally displayed
      if( document.getElementById('vue_package_id') && document.getElementById('vue_hotel_id') && 
          document.getElementById('bottom_form_customer_qty')) {
        document.getElementById('vue_package_id').getElementsByTagName('option')[0].selected = 'selected'
        document.getElementById('vue_hotel_id').getElementsByTagName('option')[0].selected = 'selected'
        document.getElementById('bottom_form_customer_qty').getElementsByTagName('option')[0].selected = 'selected'
      }
    }
  }
}
</script>
